import React, { useEffect, useState } from 'react'
import { ObjViewer } from 'react-obj-viewer'

export default function ThreeDModelComponent({
  ThreeDModelData,
  isVideoPlaying
}) {
  const { Width, Height, X, Y, ObjectUrl, TextureUrl } = ThreeDModelData

  const [width3d, setWidth3D] = useState(200)
  const [height3d, setHeight3D] = useState(200)
  const [render3D, setRender3D] = useState(true)

  const threeDmodel = {
    ObjectUrl: ObjectUrl,
    TextureUrl: TextureUrl,
    Width: Width,
    Height: Height,
    X: X,
    Y: Y
  }

  function render3DModel() {
    let ThreeParent = document.getElementById('3d-parent')
    if (ThreeParent !== null) {
      let Width3D = ThreeParent.offsetWidth
      let Height3D = ThreeParent.offsetHeight
      if (Width3D != width3d || Height3D != height3d) {
        setWidth3D(ThreeParent.offsetWidth)
        setHeight3D(ThreeParent.offsetHeight)
        setTimeout(() => {
          setRender3D(!render3D)
        }, 700)
      }
    }
    return (
      <ObjViewer
        model={ObjectUrl}
        material={TextureUrl}
        width={width3d}
        height={height3d}
      />
    )
  }

  return (
    <div
      id='3d-parent'
      style={{
        height: threeDmodel.Height + '%',
        width: threeDmodel.Width + '%',
        left: threeDmodel.X,
        top: threeDmodel.Y,
        position: 'absolute',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: '#000000',
        display: 'flex',
        alignItems: 'flex-end',
        background: '#000',
        zIndex: isVideoPlaying ? 0 : 10
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        {render3D && render3DModel()}
        {!render3D && render3DModel()}
      </div>
    </div>
  )
}
